import React from 'react';
import { handleArchiveClick } from "./NewsListHelper";

interface TranslationType {
    navigations?: {
        header?: {
            [key: string]: string | undefined | null;
            viewNewsArchive?: string | null;
            trending?: string | null;
        };
    };
    // add other keys if needed
}

interface ArchiveSectionProps {

    getUrlLanguagePrefix: (lang: string) => string;
    language: string;
    finalType: string;
    finalSubtype?: string;
    navigate: any;
    t: TranslationType;
    // showBackToTop: boolean;
    // scrollToTop: () => void;
}

const ArchiveSection: React.FC<ArchiveSectionProps> = ({

    getUrlLanguagePrefix,
    language,
    finalType,
    finalSubtype,
    navigate,
    t,
    // showBackToTop,
    // scrollToTop,
}) => {
    //   const normalizedFinalSubtype = finalSubtype ?? null;

    return (
        <>
            {/* Archive section - Always visible at the bottom */}
            <div className="w-full max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">

           

                <div className="mt-16 mb-12 border-t border-gray-200">
                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-12">
                        <button
                            onClick={() =>
                                
                                handleArchiveClick(
                                    getUrlLanguagePrefix,
                                    language,
                                    finalType,
                                    finalSubtype,
                                    navigate
                                )
                            }
                            className="w-full sm:w-auto inline-block bg-blue-600 text-white font-bold px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-200 text-center"
                        >
                            {t?.navigations?.header?.viewNewsArchive ?? 'View News Archive'}
                        </button>
                        <a
                            href={`${getUrlLanguagePrefix(language)}/news/list/trending`}
                            className="w-full sm:w-auto inline-block bg-gray-600 text-white font-bold px-6 py-3 rounded-lg hover:bg-gray-700 transition-colors duration-200 text-center"
                        >
                            {t?.navigations?.header?.trending ?? 'Trending News'}
                        </a>
                    </div>
                </div>
            </div>

            {/* {showBackToTop && (
                <button
                    onClick={scrollToTop}
                    className="fixed bottom-8 right-8 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-colors duration-200 z-50"
                    aria-label="Back to top"
                >
                    <ChevronUp size={24} />
                </button>
            )} */}
        </>
    );
};

export default ArchiveSection;
